module.exports = __webpack_public_path__ + "img/icon。支付宝支付@2x.d94df59f.png";